import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';

const backendEndpoint = environment.backendEndpoint;


@Injectable({
  providedIn: 'root'
})


export class DlrService {

  baseUrl2 = /* 'http://localhost:3030/api/v1/dlrPolicy';  // */ '/api/v1/dlrPolicy';
  endUrl   = '';

  constructor(private httpClient: HttpClient) {
    this.endUrl = backendEndpoint + this.baseUrl2;
  }

  getByCriteria(criteria) {
    return this.httpClient.post(this.endUrl, criteria, { observe: 'response' });
  }

  getDlrSummary(criteria) {
    return this.httpClient.post<any>(this.endUrl + '/getDlrSummary', criteria, { observe: 'response' });
  }

  getDlrCache(criteria) {
    return this.httpClient.post(this.endUrl + '/getDlrCache', criteria, { observe: 'response' });
  }

  insert(dlrPolicy) {
    return this.httpClient.post(this.endUrl + '/insert', dlrPolicy, { observe: 'response' });
  }

  update(dlrPolicy) {
    return this.httpClient.post(this.endUrl + '/update', dlrPolicy, { observe: 'response' });
  }

  delete(ids) {
    return this.httpClient.post(this.endUrl + '/delete', ids, { observe: 'response' });
  }

  deleteCache(criteria) {
    return this.httpClient.post(this.endUrl + '/deleteCache', criteria, { observe: 'response' });
  }

  exportExcel(criteria) {
    return this.httpClient.post(this.endUrl + '/exportExcel', criteria, { observe: 'response', responseType: 'arraybuffer' });
  }

  uploadFile(form) {
    return this.httpClient.post(this.endUrl + '/importCsvXlsx/' + JSON.stringify({
      page     : form.page,
      pageSize : form.pageSize,
      userId   : form.userId
    }), form.file, { observe: 'response' });
  }

}
